import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-professional-info',
  templateUrl: './professional-info.component.html',
  styleUrls: ['./professional-info.component.scss']
})
export class ProfessionalInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
